<div class="body">
  @if (detalleSolicitud && detalleSolicitud.propuesta) {
    <div class="container pt-3">
      <div class="row">
        @if (isDetalle) {
          <div class="col-12 col-sm-3 text-start">
            <h4>INFORMACIÓN DE LA SOLICITUD</h4>
          </div>
        }
      </div>
      <ng-content select=".app"></ng-content>
      <div class="row justify-content-md-center mt-4">
        <div class="col-12 col-sm-3">
          <div class="header-inf">
            No. de Solicitud
          </div>
          <p>{{detalleSolicitud.solicitud.idSolicitud}}</p>
        </div>
        <div class="col-12 col-sm-6">
          <div class="header-inf">
            Nombre del solicitante
          </div>
          <p>{{detalleSolicitud.empresario.primerNombre}} {{detalleSolicitud.empresario.primerApellido}}</p>
        </div>
        <div class="col-12 col-sm-3">
          <div class="header-inf">
            Monto solicitado
          </div>
          <p>{{detalleSolicitud.solicitud.monto | currency:'USD' : 'symbol' : '1.0-0'}}</p>
        </div>
      </div>
      <div class="row justify-content-md-center">
        <div class="col-12 col-sm-4">
          <div class="header-inf">
            Tipo de Identificación
          </div>
          <p>{{detalleSolicitud.empresario.nombreTipoDocumento}}</p>
        </div>
        <div class="col-12 col-sm-4">
          <div class="header-inf">
            Número de identificación
          </div>
          <p>{{detalleSolicitud.empresario.numeroDocumento}}</p>
        </div>
        <div class="col-12 col-sm-4">
          <div class="header-inf">
            Plazo solicitado (meses)
          </div>
          <p>{{detalleSolicitud.solicitud.plazo}}</p>
        </div>
      </div>
      <div class="row justify-content-md-center">
        <div class="col-12 col-sm-12">
          <div class="header-inf">
            Destino del crédito
          </div>
          <p>{{detalleSolicitud.solicitud.destino}}</p>
        </div>
      </div>
      <div class="row justify-content-md-center">
        <div class="col-12 col-sm-12">
          <div class="header-inf">
            Origen de los recursos
          </div>
          <p>{{detalleSolicitud.propuesta.origenRecursos}}</p>
        </div>
      </div>
      @if (detalleSolicitud.propuesta.origenRecursos=='RECURSOS_BANCOLDEX') {
        <form action="" id="formulario-bancoldex" class="mt-4">
          <div class="row">
            <div class="col-12 col-sm-12">
              <h5>PARÁMETROS DE LA OFERTA</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-sm-12 text-start">
              <p>Línea de crédito</p>
              <input type="text" name="lineaCreditoBancoldex" [(ngModel)]="detalleSolicitud.propuesta.modalidad" [disabled]="true">
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-sm-12 text-start">
              <p>Destino*</p>
              <input type="text" name="destinoBancoldex" [(ngModel)]="detalleSolicitud.propuesta.destino" [disabled]="true">
            </div>
          </div>
          <div class="row mt-3 text-start justify-content-md-center">
            <div class="col-12 col-sm-5">
              <p>Monto</p>
              <input type="text" name="montoBancoldex" [ngModel]="detalleSolicitud.propuesta.monto | currency:'USD' : 'symbol' : '1.0-0'" [disabled]="true">
            </div>
            <div class="col-12 col-sm-2"></div>
            <div class="col-12 col-sm-5">
              <p>Plazo en meses</p>
              <input type="text" name="plazoBancoldex" [(ngModel)]="detalleSolicitud.propuesta.plazo" [disabled]="true">
            </div>
          </div>
          <div class="row mt-3 text-start justify-content-md-center">
            <div class="col-12 col-sm-4">
              <p>Tasa Bancóldex E.A.</p>
              <input type="text" name="tazaEABancoldex" [(ngModel)]="detalleSolicitud.propuesta.tasaRedescuento" [disabled]="true">
            </div>
            <div class="col-12 col-sm-4">
              <p>Margen de intermediación E.A.</p>
              <input type="text" name="margenBancoldex" [(ngModel)]="detalleSolicitud.propuesta.margenIntermediario" [disabled]="true">
            </div>
            <div class="col-12 col-sm-4">
              <p>Tasa E.A.</p>
              <input type="text" name="tazaBancoldex" [(ngModel)]="detalleSolicitud.propuesta.tasa" [disabled]="true">
            </div>
          </div>
          <div class="row mt-3 text-start justify-content-md-center">
            <div class="col-12 col-sm-5">
              <p>Periodicidad de pago de capital e intereses</p>
              <input type="text" name="periodicidadBancoldex" [(ngModel)]="detalleSolicitud.propuesta.nombrePeriodicidad" [disabled]="true">
            </div>
            <div class="col-12 col-sm-2"></div>
            <div class="col-12 col-sm-5">
              <p>Período de gracia</p>
              <input type="text" name="periodoGraciaBancoldex" [(ngModel)]="detalleSolicitud.propuesta.periodoGracia" [disabled]="true">
            </div>
          </div>
          <div class="row mt-3 text-center justify-content-md-center">
            <div class="col-12 col-sm-4 align-self-center">
              <div class="col-12 col-sm-12 box">
                <span class="number-value">{{detalleSolicitud.propuesta.desembolsoAproximado | currency:'USD' : 'symbol' : '1.0-0'}}</span>
                <p>Valor de oferta</p>
              </div>
              <div class="col-12 col-sm-12 box">
                <span class="number-value">{{detalleSolicitud.propuesta.cuota | currency:'USD' : 'symbol' : '1.0-0'}}</span>
                <p>Valor cuota</p>
              </div>
              <div class="col-12 col-sm-12 mt-4">
                <button type="button" class="btn btn-info" style="color: white !important" (click)="downloadAll()">Revisar documentación</button>
                <a id="allFile" style="display: none;"></a>
              </div>
            </div>
            <div class="col-12 col-sm-8">
              <div class="col-12 col-sm-12 mt-4">
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col" class="no-styles table-header">Nombre de cargos y/o garantías</th>
                        <th scope="col" class="no-styles table-header">Valor</th>
                        <th scope="col" class="no-styles table-header">Tipo de cargo y/o garantías</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (cargoGarantia of detalleSolicitud.propuesta.neoCargoComisiones; track cargoGarantia; let i = $index) {
                        <tr>
                          <th scope="row">{{cargoGarantia.descripcion}}</th>
                          <td>{{cargoGarantia.monto | currency:'USD' : 'symbol' : '1.0-0'}}</td>
                          <td>{{cargoGarantia.tipoCargo}}</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="col-12 col-sm-12 mt-2" class="text-start justify-content-start">
                <p>Observaciones</p>
                @if (detalleSolicitud.observacionAprobador.observaciones == null) {
                  <textarea name="" id="" cols="80" rows="3" [disabled]="true">{{detalleSolicitud.propuesta.observaciones}}</textarea>
                }
                @if (detalleSolicitud.observacionAprobador.observaciones != null) {
                  <textarea name="" id="" cols="80" rows="3" [disabled]="true">{{detalleSolicitud.observacionAprobador.observaciones}}</textarea>
                }
              </div>
            </div>
          </div>
        </form>
      }
      @if (detalleSolicitud.propuesta.origenRecursos=='RECURSOS_PROPIOS') {
        <form action="" id="formulario-bancoldex" class="mt-4">
          <div class="row">
            <div class="col-12 col-sm-12">
              <h5>PARÁMETROS DE LA OFERTA</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-sm-12 text-start">
              <p>Línea de crédito</p>
              <input type="text" name="lineaCredito" [(ngModel)]="detalleSolicitud.propuesta.neoParametrizacionLineaDTO.nombre" [disabled]="true">
            </div>
          </div>
          <div class="row mt-3 text-start justify-content-md-center">
            <div class="col-12 col-sm-5">
              <p>Monto</p>
              <input type="text" name="monto" [ngModel]="detalleSolicitud.propuesta.monto | currency:'USD' : 'symbol' : '1.0-0'" [disabled]="true">
            </div>
            <div class="col-12 col-sm-2"></div>
            <div class="col-12 col-sm-5">
              <p>Plazo en meses</p>
              <input type="text" name="plazo" [(ngModel)]="detalleSolicitud.propuesta.plazo" [disabled]="true">
            </div>
          </div>
          <div class="row mt-3 text-start justify-content-md-center">
            <div class="col-12 col-sm-12">
              <p>Tasa EA*</p>
              <input type="text" name="tasa" [(ngModel)]="detalleSolicitud.propuesta.tasa" [disabled]="true">
            </div>
          </div>
          <div class="row mt-3 text-start justify-content-md-center">
            <div class="col-12 col-sm-5">
              <p>Periodicidad de pagos</p>
              <input type="text" name="periodicidad" [(ngModel)]="detalleSolicitud.propuesta.nombrePeriodicidad" [disabled]="true">
            </div>
            <div class="col-12 col-sm-2"></div>
            <div class="col-12 col-sm-5">
              <p>Período de gracia</p>
              <input type="text" name="periodoGracia" [(ngModel)]="detalleSolicitud.propuesta.periodoGracia" [disabled]="true">
            </div>
          </div>
          <div class="row mt-3 text-center justify-content-md-center">
            <div class="col-12 col-sm-4 align-self-center">
              <div class="col-12 col-sm-12 box">
                <span class="number-value">{{detalleSolicitud.propuesta.desembolsoAproximado | currency : 'USD' : 'symbol' : '1.0-0'}}</span>
                <p>Valor de oferta</p>
              </div>
              <div class="col-12 col-sm-12 box">
                <span class="number-value">{{detalleSolicitud.propuesta.cuota | currency:'USD' : 'symbol' : '1.0-0'}}</span>
                <p>Valor cuota</p>
              </div>
              <div class="col-12 col-sm-12 mt-4">
                <button type="button" class="btn btn-info" style="color: white !important;" (click)="downloadAll()">Revisar documentación</button>
                <a id="allFile" style="display: none;"></a>
              </div>
            </div>
            <div class="col-12 col-sm-8">
              <div class="col-12 col-sm-12 mt-4">
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col" class="no-styles table-header">Nombre de cargos y/o garantías</th>
                        <th scope="col" class="no-styles table-header">Valor</th>
                        <th scope="col" class="no-styles table-header">Tipo de cargo y/o garantías</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (cargoGarantia of detalleSolicitud.propuesta.neoCargoComisiones; track cargoGarantia; let i = $index) {
                        <tr>
                          <th scope="row">{{cargoGarantia.descripcion}}</th>
                          <td>{{cargoGarantia.monto | currency:'USD' : 'symbol' : '1.0-0'}}</td>
                          <td>{{cargoGarantia.tipoCargo}}</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="col-12 col-sm-12 mt-2" class="text-start justify-content-start">
                <p>Observaciones</p>
                @if (detalleSolicitud.observacionAprobador.observaciones == null) {
                  <textarea name="" id="" cols="80" rows="3" [disabled]="true">{{detalleSolicitud.propuesta.observaciones}}</textarea>
                }
                @if (detalleSolicitud.observacionAprobador.observaciones != null) {
                  <textarea name="" id="" cols="80" rows="3" [disabled]="true">{{detalleSolicitud.observacionAprobador.observaciones}}</textarea>
                }
              </div>
            </div>
          </div>
        </form>
      }
    </div>
  }
  @if (detalleSolicitud && !detalleSolicitud.propuesta) {
    <div class="row justify-content-md-center">
      <div class="col-12 col-sm-12 mt-4">
        <h4>La solicitud ha sido negada. No tiene una propuesta relacionada.</h4>
      </div>
    </div>
  }
  @if (isDetalle) {
    <div class="row justify-content-md-center mt-3 pb-3">
      <div class="col-12 col-sm-2 mt-4">
        <button type="button" class="btn btn-info" style="color: white !important;" (click)="goBack()">Volver</button>
      </div>
    </div>
  }
  <ng-content></ng-content>
  <div class="footer-body"></div>
</div>
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
